module.exports = __webpack_public_path__ + "static/img/s1.2dd81f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/s1.png
// module id = JAES
// module chunks = 1